import Marquee from "react-fast-marquee";

export const RibbonMarquee = ({ items }) => (
  <Marquee speed={38} gradient={false} direction="left" className="border-y border-white/10 py-5" data-testid="marquee-ribbon">
    <div className="flex items-center font-accent uppercase tracking-[0.35em] text-white/35 text-lg whitespace-nowrap">
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8">{t}</span>
          <span className="text-blaze text-[10px]">&#9670;</span>
        </span>
      ))}
    </div>
  </Marquee>
);
